import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createBootstrap } from 'bootstrap-vue-next'
import App from './components/App.vue'
import router from './router/router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/css/rm-tables.css'
import './assets/css/rm-layout.css'

import {
    BModal,
    BTable,
    BButton,
    BButtonGroup,
    BForm,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BBadge,
    BContainer,
    BRow,
    BCol,
    BCard,
    BPopover,
    BCardGroup
} from 'bootstrap-vue-next'

const app = createApp(App)

// Register Pinia stores before the router so guards and components can use them
app.use(createPinia())
app.use(router)
// Installs BootstrapVueNext plugins (modal/toast controllers, directives)
app.use(createBootstrap())
// Explicitly register BootstrapVueNext components we use
app.component('BModal', BModal)
app.component('BTable', BTable)
app.component('BButton', BButton)
app.component('BForm', BForm)
app.component('BFormGroup', BFormGroup)
app.component('BButtonGroup', BButtonGroup)
app.component('BFormSelect', BFormSelect)
app.component('BInputGroup', BInputGroup)
app.component('BFormInput', BFormInput)
app.component('BFormTextarea', BFormTextarea)
app.component('BContainer', BContainer)
app.component('BRow', BRow)
app.component('BCol', BCol)
app.component('BCard', BCard)
app.component('BPopover', BPopover)
app.component('BCardGroup', BCardGroup)
app.component('BFormCheckbox', BFormCheckbox)
app.component('BBadge', BBadge)

app.config.errorHandler = (err, instance, info) => {
  // eslint-disable-next-line no-console
  console.error(err, info)
}

// Handle Logging
// eslint-disable-next-line no-console
app.config.globalProperties.$log = console.log.bind(console)

app.mount('#app')
